module.exports = __webpack_public_path__ + "media/images/internetagentur_factor4_logo-e5edea2d2a7ad31e7a0e4a4bc758650f.svg";